import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../components/Converter";
import AlertBox from "../../../components/Messages";
import { RowBody } from "../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../components/ToolTip";
import { useGetTraggliedDatenQuery } from "../../../services/API/titanApi";
import {
  selectDisplayUtilizationError,
  selectIsUtilizationFactorValid_Statik,
  selectBerechneInnere,
} from "../../../store/slices/innereSlice";
import { selectTraggliedTitle } from "../../../store/slices/traggliedSlice";

// TODO: combine with 'Ausnutzung'
// same Code but different Formula
function UtilizationFactor() {
  const { t } = useTranslation("translation");

  const tragglied = useSelector(selectTraggliedTitle);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied);
  const { fixedN } = useSelector(selectBerechneInnere(traggliedDaten));
  const isValid = useSelector(selectIsUtilizationFactorValid_Statik(traggliedDaten));
  const showError = useSelector(selectDisplayUtilizationError(traggliedDaten));

  const nFormula = `\\displaystyle \\eta = \\frac{F_{d}}{R_{d}}`;
  let error = t("inner.verificationCapacity.utilizationFactor.errorText.toBig");
  return (
    <>
      <RowBody
        titleValue={<p>{t("inner.verificationCapacity.utilizationFactor.headline")}</p>}
        formulaValue={<ToolTip id={"nFormula"} type={IconType.FORMULA} formula={nFormula} />}
        indicesValue={<span>&eta;</span>}
        inputValue={<ResultSpan valid={isValid}>{ConvertToString(fixedN, 2)}</ResultSpan>}
      />
      <Col md={8}>
        <AlertBox show={!isValid} message={error} />
      </Col>
    </>
  );
}

export default UtilizationFactor;
